import React, { useEffect, useState } from "react";
import {
  Box, Card, CardContent, Typography, Button, TextField, Chip, Switch,
  Tooltip,
  IconButton
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { NotificationServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import {
  Visibility as VisibilityIcon,
  EditOutlined,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export default function NotificationTemplateList() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchList();
  }, [pageNumber, search]);

  const fetchList = async () => {
    try {
      setLoading(true);

      const payload = {
        pageNumber,
        pageSize: 10,
        status: [],
        search
      };

      const res = await NotificationServices.getAll(payload);

      if (res.status === 200) {
        setData(res?.data?.data?.templates || []);
        setTotalRecords(res?.data?.data?.total || 0);
      }

    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (row) => {
    const { _id, status } = row;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to update this template?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#e96c0f",
      cancelButtonColor: "#394657",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await NotificationServices.updateStatus({
            id: _id,
            status: status === 1 ? 0 : 1,
          });
  
          if (res?.status === 200) {
            toast.success(res?.data?.message || "Template updated successfully!");
            fetchList();
          } else {
            toast.error(res?.data?.message || "Something went wrong!");
          }
        } catch (error) {
          toast.error("API Error!");
        }
      }
    });
  };
  

  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => (pageNumber - 1) * 10 + index + 1,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true
    },
    {
      name: "Slug",
      selector: (row) => row.slug,
    },
    {
      name: "Message",
      selector: (row) => {
        const msg = row.message || "";
        const w = msg.trim().split(/\s+/);
        return w.length > 3 ? w.slice(0, 3).join(" ") + " ..." : msg;
      },
    },
    {
      name: "Status",
      cell: (row) => (
        <Switch
          checked={row.status === 1}
          onChange={() => handleUpdateStatus(row)}
          color="success"
        />
      ),
    },
    
    {
      name: "Actions",
      cell: (row) => (
        <Box display="flex" gap={1}>
          <Tooltip title="View Details">
            <IconButton
              onClick={() => navigate(`/notification-management/view/${row._id}`)}
              sx={{ color: "primary.main" }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton 
              onClick={() => navigate(`/notification-management/edit/${row._id}`)}
              sx={{ color: "primary.main" }}
            >
              <EditOutlined />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h4">Notification Templates</Typography>
            {/* <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/notification-management/add")}
            >
              Add New
            </Button> */}
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>

          <DataTable
            columns={columns}
            data={data}
            progressPending={loading}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={totalRecords}
            paginationPerPage={10}
            onChangePage={(page) => setPageNumber(page)}
          />
        </CardContent>
      </Card>
    </Box>
  );
}
